function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("text", {
  transform: "translate(0 47.52)",
  fill: "#fff",
  fontFamily: "ArialMTPro-Bold,Arial MT Pro",
  fontWeight: 700,
  fontSize: 15.13
}, "IFISA");

var _ref2 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(9 31.92)",
  fontSize: 37.2,
  fill: "#fff",
  fontFamily: "ArialMTPro-Bold,Arial MT Pro",
  fontWeight: 700
}, "\xA3");

var SvgIfisaIcon = function SvgIfisaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38.68 52.09"
  }, props), _ref, _ref2);
};

export default SvgIfisaIcon;